module.exports = __webpack_public_path__ + "static/img/200254.1ae56fac.png";